<template>
  <header class="header">
    <container>
      <div class="header__content header__desktop">
        <router-link to="/" class="logo">
          <img src="../assets/images/header/logo.svg" alt="">
        </router-link>
        <custom-select v-if="!!getCities" @change="(city) => setCity(city)" :value="getCity">
          <option v-for="city in getCities" :key="city.id" :value="city.id">{{ city.name }}</option>
        </custom-select>
        <router-link :to="{name: 'master.list'}" class="link">
          Мастера
        </router-link>
        <router-link :to="{name: 'coworking.show', params: {id: 1}}" class="link" v-if="ifSingle">
          Наши услуги и цены
        </router-link>
        <router-link :to="{name: 'coworking.list'}" class="link" v-else>
          Коворкинги
        </router-link>
        <div v-if="isUserAuth" class="ml-auto" style="position: relative">
          <a href="javascript:void(0)" class="avatar" @click="userDropDown = !userDropDown">
            <img v-if="getUser.avatar" :src="getUser.avatar" alt="">
            <span v-if="getUser.full_name">{{ getUser.full_name }}</span>
            <span v-else>{{ getUser.phone }}</span>
          </a>
          <transition name="fade">
            <div v-if="userDropDown" class="avatar-dropdown">
              <div class="avatar-dropdown-item" @click="$router.push({name: getRole+'.cabinet'});userDropDown = false">
                Кабинет
              </div>
              <div class="avatar-dropdown-item" @click="logout">
                Выйти
              </div>
            </div>
          </transition>
        </div>
        <template v-else>
          <button class="registerLink" @click="openModal('register_main')">Регистрация</button>
          <button-component size="small" @click="openModal('login')">Вход</button-component>
        </template>
      </div>
      <div class="header__mobile">
        <button class="openMenu" @click="drawerIsOpened = true">
          <img src="../assets/images/header/menu.svg" alt="">
        </button>
        <router-link to="/" class="mobileLogo">
          <img src="../assets/images/header/logo_mobile.svg" alt="">
        </router-link>
      </div>
    </container>
    <Modals/>
    <div class="drawer" :class="{drawerIsOpened}" @click="drawerClick" ref="drawer">
      <div class="drawer__content">
        <div class="drawer__header">
          <router-link to="/" class="userMobile" v-if="isUserAuth">
            <div class="ava" v-if="getUser.avatar">
              <img :src="getUser.avatar" alt="">
            </div>
            <span v-if="getUser.full_name" class="name">{{ getUser.full_name }}</span>
            <span v-else class="name">{{ getUser.phone }}</span>
          </router-link>
          <div class="buttons" v-else>
            <button class="register" @click="openModalFromDrawer('register_main')">
              Регистрация
            </button>
            <button class="login" @click="openModalFromDrawer('login')">
              Вход
            </button>
          </div>
        </div>
        <div class="drawer__links">
          <ul>
            <!-- Links by default -->
            <li>
              <span @click="drawerIsOpened = false">
                <router-link to="/masters">Мастера</router-link>
              </span>
            </li>
            <li v-if="ifSingle"><span @click="drawerIsOpened = false">
              <router-link :to="{name: 'coworking.show', params: {id: 1}}">Наши услуги и цены</router-link>
            </span></li>
            <li v-else><span @click="drawerIsOpened = false" >
              <router-link to="/coworking">Коворкинги</router-link>
            </span></li>
            <li v-if="drawerLinks.length > 0">
              <div class="line"></div>
            </li>
            <!-- Dynamic links  -->
            <li
                v-for="(l, i) in drawerLinks"
                :key="i"
            >
              <div class="line" v-if="l.isLine"></div>
              <span @click="drawerIsOpened = false" v-else>
                <span v-if="l.withNewBonuses" class="green__dot"></span>
                <router-link :to="l.path">{{ l.name }}</router-link>
              </span>
            </li>
            <!-- Exit link -->
            <template v-if="isUserAuth">
              <li>
                <div class="line"></div>
              </li>
              <li>
                <a href="#" @click="logout">Выход</a>
              </li>
            </template>
          </ul>
          <div class="drawer__links__bottom">
            <custom-select v-if="!!getCities" @change="(city) => setCity(city)" :value="getCity">
              <option v-for="city in getCities" :key="city.id" :value="city.id">{{ city.name }}</option>
            </custom-select>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import CustomSelect from './ui/inputs/custom-select'
import Container from './grid/Container'
import ButtonComponent from '@/components/ui/buttons/button-component'
import { mapGetters, mapMutations } from 'vuex'
import Modals from '@/components/Modals/Modals'

export default {
  name: 'Header',
  components: {
    Modals,
    ButtonComponent,
    Container,
    CustomSelect
  },
  data: () => ({
    userDropDown: false,
    drawerIsOpened: false,
    client_links: [
      {path: '/cabinet/records', name: 'Мои записи'},
      {path: '/cabinet/client/bonus', name: 'Бонусная программа', withNewBonuses: true},
      {isLine: true},
      {path: '/cabinet/client/messages', name: 'Сообщения'},
      {path: '/cabinet/client/notifications', name: 'Уведомления'},
      {isLine: true},
      {path: '/cabinet/client/settings', name: 'Настройки'}
    ],
    master_links: [
      {path: '/cabinet/master/calendar/rents', name: 'Календарь'},
      {path: '/cabinet/master/clients', name: 'Мои клиенты'},
      {path: '/cabinet/master/packages', name: 'Пакеты часов'},
      {path: '/cabinet/master/analytics', name: 'Аналитика'},
      {path: '/cabinet/master/portfolio', name: 'Портфолио'},
      {path: '/cabinet/master/bonus', name: 'Бонусная программа', withNewBonuses: true},
      {isLine: true},
      {path: '/cabinet/master/messages', name: 'Сообщения'},
      {path: '/cabinet/master/notifications', name: 'Уведомления'},
      {isLine: true},
      {path: '/cabinet/master/settings', name: 'Настройки'}
    ],
    admin_links: [
      {path: '/cabinet/admin/calendar', name: 'Календарь'},
      {path: '/cabinet/admin/messages', name: 'Чат'},
      {path: '/cabinet/admin/statistics', name: 'Аналитика'},
      {path: '/cabinet/admin/masters', name: 'Мастера'},
      {path: '/cabinet/admin/client', name: 'Регистрация клиента'},
      {path: '/cabinet/admin/offlinePurchase', name: 'Офлайн покупка'},
    ]
  }),
  mounted() {
    this.loadCities()
  },
  computed: {
    ...mapGetters(['isUserAuth', 'getCities', 'getCity', 'getUser', 'getRole']),
    ifSingle(){
      return process.env.VUE_APP_SINGLECOWORKING == 'true'
    },
    drawerLinks() {
      if (this.getUser) {
        switch (this.getUser.type) {
          case 'client':
            return this.client_links
          case 'master':
            return this.master_links
          case 'admin':
            return this.admin_links
          default:
            return []
        }
      }
      return []
    }
  },
  methods: {
    ...mapMutations(['closeModals', 'openModal', 'signOut', 'setCities', 'setCity']),
    loadCities() {
      this.$api.city.all({exists: true}).then(({data}) => this.setCities(data))
    },
    logout() {
      this.$api.auth.logout()
          .then(() => {
            if (this.$route.name !== "home") this.$router.push({name: 'home'})
          }).finally(() => this.signOut())
    },
    drawerClick(e) {
      if (e.target === this.$refs.drawer) {
        this.drawerIsOpened = false
      }
    },
    openModalFromDrawer(modal_name) {
      this.drawerIsOpened = false
      this.openModal(modal_name)
    }
  },
  watch: {
    drawerIsOpened(v) {
      const $body = document.querySelector('body')
      if (v) {
        $body.classList.add('overflow_hidden')
      } else {
        $body.classList.remove('overflow_hidden')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  height: 90px;
  background: #FFFFFF;
  border-bottom: 1px solid #DBBFA7;
  box-shadow: 0 1px 10px rgba(219, 191, 167, 0.1);

  &__mobile {
    display: none;
  }

  &__content {
    height: 100%;
    display: flex;
    align-items: center;
  }
}

.ml-auto {
  margin-left: auto;
}

.registerLink {
  font-family: "Open Sans", sans-serif;
  margin-right: 20px;
  margin-left: auto;
  text-decoration: none;
  font-size: 16px;
  line-height: 1.5;
  color: #383838;
  border: none;
  background-color: transparent;
}

.logo {
  height: 60px;
  margin-right: 50px;

  img {
    height: 100%;
  }
}

.link {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: #383838;
  text-decoration: none;
  margin-left: 50px;
  font-family: "Open Sans", sans-serif;
}

.avatar {
  border: 1px solid #DBBFA7;
  border-radius: 25px 5px 5px 25px;
  display: flex;
  align-items: center;
  height: 50px;
  margin-left: auto;
  text-decoration: none;
  background: white;

  &-dropdown {
    z-index: 9999;
    margin-top: 10px;
    background: white;
    color: #383838;
    width: 100%;
    position: absolute;
    border: 1px solid #dbbfa7;
    padding: 5px;
    border-radius: 5px;

    &-item {
      text-align: center;
      padding: 6px;

      a {
        color: #383838;
        text-decoration: none;
      }

      &:hover {
        cursor: pointer;
        background: #dbbfa7;
        transition: .3s;
        border-radius: 5px;
      }
    }
  }

  img {
    transform: translateX(-1px);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 1px solid #DBBFA7;
    object-fit: cover;
  }

  span {
    font-size: 16px;
    color: #383838;
    padding-left: 10px;
    padding-right: 15px;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}

.drawer {
  z-index: 9999;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  pointer-events: none;
  transition: 300ms opacity ease;

  &.drawerIsOpened {
    opacity: 1;
    pointer-events: all;

    .drawer__content {
      transform: translateX(0);
    }
  }

  &__content {
    transform: translateX(-100%);
    transition: 300ms transform ease;
    overflow: auto;
    width: 270px;
    background-color: #fff;
    height: 100%;
  }

  &__header {
    display: flex;
    align-items: center;
    background: #DBBFA7;
    padding: 20px;
    height: 90px;

    .userMobile {
      display: flex;
      align-items: center;
      text-decoration: none;

      .ava img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
        object-fit: cover;
      }

      .name {
        margin-left: 10px;
        font-weight: 600;
        font-size: 16px;
        line-height: 1;
        color: #383838;
      }
    }

    .buttons {
      display: flex;
      align-items: center;
      justify-content: center;

      button {
        border: none;
        margin: 0 10px;
        font-size: 16px;
        font-family: "Open Sans", sans-serif;
      }

      .register {
        color: #383838;
        background-color: transparent;
      }

      .login {
        border-radius: 5px;
        background-color: #FFFFFF;
        padding: 14px 20px;
        font-weight: 600;
      }
    }
  }

  &__links {
    padding: 20px;

    ul {
      list-style: none;

      li {
        position: relative;
        margin-bottom: 15px;

        a {
          text-decoration: none;
          font-size: 16px;
          line-height: 1.5;
          color: #383838;
        }

        .line {
          width: 100%;
          height: 1px;
          background-color: #E5E5E5;
          margin: 20px 0;
        }
      }
    }

    &__bottom {
      margin-top: 30px;
    }
  }
}

@media screen and (max-width: 1170px) {
  .header {
    height: 60px;
    padding: 10px 0;

    &__desktop {
      display: none;
    }

    &__mobile {
      position: relative;
      display: block;
    }

    .openMenu {
      background-color: transparent;
      width: 40px;
      height: 40px;
      border: none;
    }

    .mobileLogo {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.green__dot {
  position: absolute;
  left: -15px;
  display: block;
  width: 10px;
  height: 10px;
  background-color: #0F8A84;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);
}
</style>
